var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlightChecks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m17 16.249-5.912-1.841v4.053l1.487 1.115v1.097l-2.584-.725-2.566.725v-1.097l1.45-1.115v-4.053L3 16.248v-1.451l5.877-3.7V7.045q0-.46.317-.779a1.08 1.08 0 0 1 .797-.318 1.074 1.074 0 0 1 1.097 1.097v4.053l5.912 3.7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m2.407-5.21a.5.5 0 0 0-.814-.58l-2.157 3.02-1.082-1.083a.5.5 0 0 0-.708.707l1.5 1.5a.5.5 0 0 0 .76-.063z",
  clipRule: "evenodd"
})));
export default SvgFlightChecks;